export enum AccessLevel {
  Public = 'Public',
  Private = 'Private',
}
